import React from 'react';
import './IconEvents.css';

export const IconEvents = ({ name }) => {
  if (!name) return null

  name = name.replace(/ /g, '-').toLowerCase()

  const icons = {
    list: list(),
    calendar: calendar(),
  }

  return icons[name] || null
}

const list = () => {
  return (
    <svg className="icon icon-list"
         width="100%"
         height="100%"
         viewBox="0 0 24 30"
         preserveAspectRatio="xMidYMid meet"
         style={{ fillRule: 'evenodd', clipRule: 'evenodd', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: 1 }}>

      <path d="M1,7l22,0M1,15l22,0M1,23l22,0"
        style={{ fill: 'none', stroke: 'rgb(224,218,212)', strokeWidth: '2px' }} />

      {/* Active-state variant must be a CLOSED, fillable shape — same rule as
          IconStories' "list" icon. */}
      <path className="fill" d="M1,5h22v4h-22zM1,13h22v4h-22zM1,21h22v4h-22z"
        style={{ fill: '#222020', stroke: 'none' }} />
    </svg>
  )
}

const calendar = () => {
  return (
    <svg className="icon icon-calendar"
         width="100%"
         height="100%"
         viewBox="0 0 24 30"
         preserveAspectRatio="xMidYMid meet"
         style={{ fillRule: 'evenodd', clipRule: 'evenodd', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: 1 }}>

      <path d="M2,10h20M2,10v15a2,2 0 0,0 2,2h16a2,2 0 0,0 2,-2v-15M2,10v-2a2,2 0 0,1 2,-2h16a2,2 0 0,1 2,2v2M7,3v5M17,3v5M6,15h3M11,15h3M16,15h2M6,20h3M11,20h3M16,20h2"
        style={{ fill: 'none', stroke: 'rgb(224,218,212)', strokeWidth: '2px' }} />

      {/* Closed header bar — same "must be a fillable shape" rule as other apps' nav icons */}
      <path className="fill" d="M2,8a2,2 0 0,1 2,-2h16a2,2 0 0,1 2,2v2h-20z"
        style={{ fill: '#222020', stroke: 'none' }} />
    </svg>
  )
}
